const DASHBOARD_API_URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:5000").replace(/\/$/, "");
const BASE_URL = (process.env.REACT_APP_SEO_AGENT_API_URL || `${DASHBOARD_API_URL}/api/seo-agent`).replace(/\/$/, "");

const DEFAULT_EMAIL = process.env.REACT_APP_SEO_AGENT_EMAIL || "admin@local.example.test";
const DEFAULT_PASSWORD = process.env.REACT_APP_SEO_AGENT_PASSWORD || "local-admin-change-before-shared-use";

let session = {
  accessToken: window.localStorage.getItem("seo-agent-access-token") || "",
  tenantId: window.localStorage.getItem("seo-agent-tenant-id") || "",
};

function headers(extra = {}) {
  return {
    "Content-Type": "application/json",
    ...(session.accessToken ? { Authorization: `Bearer ${session.accessToken}` } : {}),
    ...(session.tenantId ? { "x-tenant-id": session.tenantId } : {}),
    ...extra,
  };
}

async function request(path, options = {}) {
  let response;
  try {
    response = await fetch(`${BASE_URL}${path}`, {
      ...options,
      headers: headers(options.headers),
    });
  } catch {
    throw new Error(`SEO Agent backend is offline. Start it at ${BASE_URL}.`);
  }

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body?.error?.message || body?.message || `Request failed (${response.status}).`);
    error.code = body?.error?.code;
    error.details = body?.error?.details;
    error.status = response.status;
    throw error;
  }
  return body;
}

export const seoAgentAPI = {
  baseUrl: BASE_URL,
  health: () => request("/health"),
  login: async ({ email = DEFAULT_EMAIL, password = DEFAULT_PASSWORD } = {}) => {
    const body = await request("/v1/auth/login", {
      method: "POST",
      body: JSON.stringify({ email, password }),
    });
    session = {
      accessToken: body.data?.accessToken || "",
      tenantId: body.data?.activeTenantId || "",
    };
    window.localStorage.setItem("seo-agent-access-token", session.accessToken);
    window.localStorage.setItem("seo-agent-tenant-id", session.tenantId);
    return body;
  },
  sites: () => request("/v1/sites"),
  overview: (siteId) => request(`/v1/sites/${siteId}/seo-overview`),
  connectSite: (payload) => request("/v1/sites", {
    method: "POST",
    body: JSON.stringify(payload),
  }),
  syncSite: (siteId) => request(`/v1/sites/${siteId}/sync`, {
    method: "POST",
    body: JSON.stringify({}),
  }),
  job: (jobId) => request(`/v1/jobs/${jobId}`),
  sendCommand: ({ siteId, contentId, message }) => request("/v1/assistant/command", {
    method: "POST",
    body: JSON.stringify({ siteId, contentId, message }),
  }),
  publish: (publishEndpoint) => request(publishEndpoint, {
    method: "POST",
    body: JSON.stringify({}),
  }),
  downloadConnector: async () => {
    const response = await fetch(`${BASE_URL}/v1/connector/download`, {
      method: "GET",
      headers: headers(),
    });
    if (!response.ok) {
      const body = await response.json().catch(() => ({}));
      const error = new Error(body?.error?.message || `Connector download failed (${response.status}).`);
      error.code = body?.error?.code;
      throw error;
    }
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = "causalfunnel-seo-connector-1.0.0.zip";
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(url);
  },
};
